var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "quartz-core": "static-1.6320"
    },
    "depPathPrefixes": {
      "quartz-core": "/quartz-core/static-1.6320"
    },
    "bundlingPackage": "feedback-public-submission-ui",
    "bundlingPackageVersion": "static-1.30390",
    "project": "quartz-core",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};